import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"

function Pagination({ pageContext }) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          slugs {
            page
          }
        }
      }
    }
  `)
  const paginationUrl = pageContext.url
  const { page: pageSlug } = siteSettings.site.siteMetadata.slugs
  const { previousPagePath, nextPagePath, humanPageNumber, numberOfPages } =
    pageContext
  let lastVisiblePage = 0

  return (
    <>
      {numberOfPages > 1 && (
        <nav
          className="flex justify-center pt-16"
          role="navigation"
          aria-label="Pagination Navigation"
        >
          <ul className="inline-flex flex-wrap font-medium text-sm -m-1">
            <li className="m-1">
              {previousPagePath ? (
                <Link
                  to={`${previousPagePath}/`}
                  className="inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-4 rounded-full text-gray-300 hover:bg-purple-600 transition-colors duration-150 ease-in-out"
                >
                  Prev
                </Link>
              ) : (
                <span className="inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-4 rounded-full text-gray-500">
                  Prev
                </span>
              )}
            </li>

            {[...Array(numberOfPages)].map((_, i) => {
              const page = i + 1
              const visiblePage =
                page === 1 ||
                page === numberOfPages ||
                page === humanPageNumber ||
                (humanPageNumber > 1 &&
                  humanPageNumber < numberOfPages &&
                  (page === humanPageNumber - 1 ||
                    page === humanPageNumber + 1)) ||
                (humanPageNumber === 1 && page <= 3) ||
                (humanPageNumber === numberOfPages && page >= numberOfPages - 2)

              const pageElement = (
                <li className="m-1" key={i}>
                  <Link
                    to={
                      i === 0
                        ? `${paginationUrl}/`
                        : `${paginationUrl}${pageSlug}/${i + 1}/`
                    }
                    className={`${
                      i + 1 === humanPageNumber && "bg-purple-600"
                    } inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-2 rounded-full text-gray-300 hover:bg-purple-600 transition-colors duration-150 ease-in-out`}
                  >
                    {i + 1}
                  </Link>
                </li>
              )

              const ellipsisElement = (
                <li className="m-1" key={i + 10000}>
                  <span className="inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-2 rounded-full text-gray-500">
                    ...
                  </span>
                </li>
              )

              let elements = []

              if (visiblePage) {
                if (page - lastVisiblePage > 1) {
                  elements.push(ellipsisElement)
                }
                elements.push(pageElement)
                lastVisiblePage = page
              } else if (
                i === numberOfPages - 1 &&
                page - lastVisiblePage > 0
              ) {
                elements.push(ellipsisElement)
              }

              return elements
            })}

            <li className="m-1">
              {nextPagePath ? (
                <Link
                  to={`${nextPagePath}/`}
                  className="inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-4 rounded-full text-gray-300 hover:bg-purple-600 transition-colors duration-150 ease-in-out"
                >
                  Next
                </Link>
              ) : (
                <span className="inline-flex h-10 min-w-10 justify-center items-center bg-gray-800 px-4 rounded-full text-gray-500">
                  Next
                </span>
              )}
            </li>
          </ul>
        </nav>
      )}
    </>
  )
}

export default Pagination
